import { Divider } from 'components/material-ui-styles';
import { Box, Checkbox, FormControlLabel, FormHelperText, TextField } from '@mui/material';
import { useTenantRegisterServiceForm } from 'TenantModule/hooks/useTenantRegisterServiceForm';
import { ServiceNameSelector } from './ServiceNameSelector';
import RealmSelector from 'SandboxModule/components/RealmSelector';
import { TenantSelector } from '../TenantSelector';
import { MaskedInput } from 'components/MaskedInput';
import { StyledDefaultPrimaryButton } from 'styles';
import { DbCredentialFields } from './DbCredentialFields';

export const TenantRegisterServiceForm: React.FC<
  ReturnType<typeof useTenantRegisterServiceForm>
> = ({
  registerTenantServiceParams,
  isRegisteringServiceToTenant,
  onRegisterServiceFormChange,
  onTenantSelectorClick,
  onRealmSelectorClick,
  realmDropdownRef,
  selectedRealm,
  selectedTenant,
  isSecretNameFieldRequired,
  isUsingDefaultDb,
  areSomeDbFieldsFilled,
  onSubmitTenantRegisterServiceForm,
}) => {
  return (
    <form onSubmit={onSubmitTenantRegisterServiceForm}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-evenly',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          {selectedTenant ? (
            <TenantSelector onClick={onTenantSelectorClick} tenantId={selectedTenant?.id} />
          ) : (
            <></>
          )}
          <RealmSelector
            onClick={onRealmSelectorClick}
            realmId={selectedRealm?.realm_id || ''}
            ref={realmDropdownRef}
          />
          <ServiceNameSelector
            value={registerTenantServiceParams.integrationAgentName || ''}
            onChange={onRegisterServiceFormChange}
            disabled={isRegisteringServiceToTenant}
          />
          <MaskedInput
            label="API Key"
            name="apiKeySecret"
            value={registerTenantServiceParams.apiKeySecret}
            onChange={onRegisterServiceFormChange}
            variant="outlined"
            disabled={isRegisteringServiceToTenant}
            helperText="Optional — leave blank to auto-generate one"
          />
          <TextField
            label="Service Region"
            name="serviceRegion"
            type="text"
            value={registerTenantServiceParams.serviceRegion}
            onChange={onRegisterServiceFormChange}
            variant="outlined"
            disabled={isRegisteringServiceToTenant}
          />
          <TextField
            label="Service IP Address"
            name="serviceIPAddress"
            type="text"
            value={registerTenantServiceParams.serviceIPAddress}
            onChange={onRegisterServiceFormChange}
            variant="outlined"
            disabled={isRegisteringServiceToTenant}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={registerTenantServiceParams.useDefault}
                onChange={onRegisterServiceFormChange}
                name="useDefault"
                color="primary"
              />
            }
            label="use Default"
          />
          {!isUsingDefaultDb ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
              }}
            >
              <h3>Enter the Secret Name</h3>
              <TextField
                required={isSecretNameFieldRequired}
                label="Secret Name"
                name="dbSecretName"
                type="text"
                value={registerTenantServiceParams.dbSecretName}
                onChange={onRegisterServiceFormChange}
                variant="outlined"
                disabled={isRegisteringServiceToTenant}
                helperText="Existing AWS secret that decides which database cluster the service uses, e.g. Tenant/default-backend"
              />
              <h3>Create new with DB credentials</h3>
              <FormHelperText>
                Optional — only used when the secret above does not exist yet. Fill in all five
                fields or none.
              </FormHelperText>
              <DbCredentialFields
                onRegisterServiceFormChange={onRegisterServiceFormChange}
                registerTenantServiceParams={registerTenantServiceParams}
                disabledFields={isRegisteringServiceToTenant}
                required={areSomeDbFieldsFilled}
              />
            </Box>
          ) : null}
        </Box>
      </Box>
      <Divider sx={{ my: 6 }} />
      <StyledDefaultPrimaryButton type="submit" disabled={isRegisteringServiceToTenant}>
        Submit
      </StyledDefaultPrimaryButton>
    </form>
  );
};
